/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

import {
	MintStatus,
	STATUS_LABEL,
	STATUS_MESSAGE,
	STATUS_PERCENT_MAPPING,
} from '@config/constants/mint-status';
import { TMintHistory } from '@features/sourcing/mint-history/types';
import { MINT_STATUS_TRANSACTION_FILTER_OPTIONS } from '@utils/options';

/* -------------------------------------------------------------------------- */
/*                                  Helpers                                   */
/* -------------------------------------------------------------------------- */

export const getMintHistoryPercent = (
	_mintStatus: string,
	_pinStatus: string,
	_status: string
) => {
	const key = `${_pinStatus},${_mintStatus},${_status}`;
	return STATUS_PERCENT_MAPPING[key] || '0';
};

export const getMintHistoryStatus = (
	_mintStatus: string,
	_pinStatus: string,
	_status: string,
	_progress: string
) => {
	const key = `${_pinStatus},${_mintStatus},${_status}${_progress == '60' ? ',' + _progress : ''}`;
	return (
		STATUS_MESSAGE[key] ||
		`PIN : ${_pinStatus} , MINT : ${_mintStatus} , STATUS : ${_status}`
	);
};

export const getMintStatusLabel = (
	_mintStatus: string,
	_pinStatus: string,
	_status: string
) => {
	const key = `${_pinStatus},${_mintStatus},${_status}`;
	return (
		STATUS_LABEL[key] ||
		`PIN : ${_pinStatus} , MINT : ${_mintStatus} , STATUS : ${_status}`
	);
};

export function getLabelFromValue(value?: string) {
	const option =
		MINT_STATUS_TRANSACTION_FILTER_OPTIONS.find(
			(option) => option.value === value
		);

	if (option) {
		return option.label;
	} else {
		return value;
	}
}

export const getMintStatusColor = (
	_mintStatusColor?: string
) => {
	switch (_mintStatusColor) {
		case MintStatus.ERROR:
			return 'error';
		case MintStatus.PENDING:
			return 'warning';
		case MintStatus.IN_PROGRESS:
			return 'warning';
		case MintStatus.SUCCESS:
			return 'success';
		case MintStatus.BYPASSED:
			return 'success';

		default:
			return 'default';
	}
};

export const isAllStatusSuccess = (
	_list: TMintHistory[]
) => {
	return _list.every(
		(item: TMintHistory) =>
			item.status &&
			(item.status.toUpperCase() === 'SUCCESS' ||
				item.status.toUpperCase() === 'BYPASSED') &&
			item.mint &&
			item.mint.status &&
			(item.mint.status.toUpperCase() === 'SUCCESS' ||
				item.mint.status.toUpperCase() === 'BYPASSED') &&
			item.pin &&
			item.pin.status &&
			(item.pin.status.toUpperCase() === 'SUCCESS' ||
				item.pin.status.toUpperCase() === 'BYPASSED')
	);
};
